// Access Levels
import React, { useContext } from "react";
import { GrigoraDashboardContext } from "../dashboard/context";
import { AccountContext } from "../account/account";

var PREDEFINED_ROLES_ACCESS = {
  administrator: [0, 4000, 5000],
  editor: [
    1001, 1004, 1005, 1006, 1008, 3000, 4000, 5001, 5002, 5004, 5006, 5012,
    5013,
  ],
  author: [3000, 4002, 4004, 4108, 4105, 4007, 5003, 5005, 5014],
  contributor: [3000, 4002, 4108, 4007, 5003, 5005, 5014],
};
function AccessControl({
  allowedPermissionCodes = [],
  forceAllowed = false,
  forceDisallowed = false,
  children,
}) {
  const { project } = useContext(GrigoraDashboardContext) ?? {};
  const { userAttributes } = useContext(AccountContext) ?? {};

  const selfRole =
    userAttributes?.sub &&
    project.members &&
    project.members[userAttributes?.sub]?.privilege
      ? project.members[userAttributes?.sub]?.privilege
      : undefined;

  var selfRoleAccess = PREDEFINED_ROLES_ACCESS[selfRole] ?? [];

  if (forceAllowed) {
    return <>{children}</>;
  }

  if (forceDisallowed) {
    return <></>;
  }

  if (!allowedPermissionCodes.some((item) => selfRoleAccess.includes(item))) {
    return <></>;
  }

  return <>{children}</>;
}

function hasAccess(allowedPermissionCodes = [], forceAllowed = false) {
  const { project } = useContext(GrigoraDashboardContext) ?? {};
  const { userAttributes } = useContext(AccountContext) ?? {};

  const selfRole =
    userAttributes?.sub &&
    project.members &&
    project.members[userAttributes?.sub]?.privilege
      ? project.members[userAttributes?.sub]?.privilege
      : undefined;

  var selfRoleAccess = PREDEFINED_ROLES_ACCESS[selfRole] ?? [];

  if (forceAllowed) {
    return true;
  }

  if (!allowedPermissionCodes.some((item) => selfRoleAccess.includes(item))) {
    return false;
  }

  return true;
}

function hasAccessNoHooks(
  project,
  userID,
  allowedPermissionCodes = [],
  forceAllowed = false,
) {
  const selfRole =
    userID && project.members && project.members[userID]?.privilege
      ? project.members[userID]?.privilege
      : undefined;

  var selfRoleAccess = PREDEFINED_ROLES_ACCESS[selfRole] ?? [];

  if (forceAllowed) {
    return true;
  }

  if (!allowedPermissionCodes.some((item) => selfRoleAccess.includes(item))) {
    return false;
  }

  return true;
}

export { AccessControl, hasAccess, hasAccessNoHooks };
